import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator, GoogleAuthProvider } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';

const host = 'localhost';
const mode = import.meta.env.MODE;
/** When true, use Auth/Firestore emulators (local). */
const forceFirebaseEmulator =
  import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true';
/**
 * In dev, default is emulators. Set VITE_USE_PRODUCTION_FIREBASE=true (e.g. in .env.local)
 * to use hosted Firebase + app.trovepile.com auth while running `npm run dev`.
 */
const useProductionFirebaseInDev = import.meta.env.VITE_USE_PRODUCTION_FIREBASE === 'true';
/**
 * Gate the emulator decision on `MODE`, NOT `import.meta.env.PROD`.
 *
 * The embedded extension dev build runs `vite build --mode development`, which
 * leaves `import.meta.env.PROD === true` (Vite only flips PROD when NODE_ENV is
 * forced to `development`, which no env file does). A PROD-gated check therefore
 * made the embedded SPA talk to *production* Firebase while the service worker
 * uses the local emulator. The page then reloaded the persisted emulator user
 * against prod Identity Toolkit (HTTP 400) and CLEARED the SW-owned session
 * (shared `[DEFAULT]`-app IndexedDB on the extension origin), bouncing the user
 * back to `/login` on every refresh. `MODE` is the reliable discriminator
 * (production build => 'production').
 */
const useFirebaseEmulator =
  mode !== 'production' &&
  !useProductionFirebaseInDev &&
  (forceFirebaseEmulator || mode === 'development');
// Chrome extensions can't use a custom authDomain (CORS/CSP restrictions); use the default firebaseapp.com domain instead.
const isExtension = typeof window !== 'undefined' && window.location.protocol === 'chrome-extension:';

const firebaseConfig = useFirebaseEmulator
? {
    apiKey: 'AIzaSyAih6uQrRHigGORdAiUJcdGRzyINh-EVL8',
    authDomain: `${host}:9099`,
    projectId: 'trovepile-39142',
    storageBucket: 'trovepile-39142.appspot.com',
    messagingSenderId: '887729215749',
    appId: '1:887729215749:web:adac43e585751a75b07f6c',
    measurementId: 'G-SCTQBQJ4Q0',
    databaseURL: `http://${host}:9000/?ns=trovepile-39142`,
  }
: {
    apiKey: "AIzaSyAih6uQrRHigGORdAiUJcdGRzyINh-EVL8",
    authDomain: isExtension ? 'trovepile-39142.firebaseapp.com' : 'app.trovepile.com',
    databaseURL: "https://trovepile-39142-default-rtdb.firebaseio.com",
    projectId: "trovepile-39142",
    storageBucket: "trovepile-39142.appspot.com",
    messagingSenderId: "887729215749",
    appId: "1:887729215749:web:adac43e585751a75b07f6c",
    measurementId: "G-SCTQBQJ4Q0"
  };

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

if (useFirebaseEmulator && firebaseConfig.authDomain.includes(':9099')) {
  connectAuthEmulator(auth, `http://${host}:9099`, {
    disableWarnings: true,
  });
  connectFirestoreEmulator(db, host, 8080);
  console.log('Firebase Auth Emulator connected');
}
